// extracted by mini-css-extract-plugin
export default {"pulsatingDotForCopyStyles":"fancy-text-bottom-bar-module__pulsatingDotForCopyStyles--nnn6l"};